import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TrashIcon } from '../../../assets';
import { Confirm } from '../../../context/confirm/confirm';
import { TextInput } from '../../inputs/TextInput';
import PlatformIcons from './influencer/PlatformsIcons';

export default function DisclaimerPlatforms({
  disclaimer,
  updateDisclaimer,
  deleteDisclaimer,
}: {
  disclaimer: {
    id: string;
    disclaimer: string;
    platform: any;
  };
  updateDisclaimer: (description: any) => void;
  deleteDisclaimer: any;
}) {
  const platformsString = disclaimer.platform ? disclaimer.platform : '';
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const [platforms, setPlatforms] = useState(
    platformsString === ''
      ? []
      : platformsString.split(',').map((item: any) => item.trim()),
  );
  const [textDisclaimer, setTextDisclaimer] = useState(disclaimer.disclaimer);

  const handleUpdate = (newPlatforms: string[]) => {
    updateDisclaimer({
      ...disclaimer,
      platform: newPlatforms.join(','),
      disclaimer: textDisclaimer,
    });
  };
  const onClickPlatform = (platform: string) => {
    setPlatforms((prevPlatforms: any) => {
      const updatedPlatforms = prevPlatforms.includes(platform)
        ? prevPlatforms.filter((p: any) => p !== platform)
        : [...prevPlatforms, platform];
      handleUpdate(updatedPlatforms);
      return updatedPlatforms;
    });
  };
  return (
    <div className="flex flex-row gap-3 items-center">
      <Confirm
        open={open}
        onConfirm={() => deleteDisclaimer()}
        setOpen={setOpen}
        type="delete"
        title={t('global.deleteTitle')}
        subtitle={t('global.deleteSubtitle')}
        confirmText={t('global.delete')}
        cancelText={t('global.cancel')}
      />

      <div className="w-full">
        <div className="flex flex-row gap-2.5">
          <TextInput
            maxLength={6000}
            selectedValue={disclaimer.disclaimer}
            type="text"
            onSelectChange={(value: any) => {
              setTextDisclaimer(String(value));
            }}
            onBlur={() => handleUpdate(platforms)}
            extraClassname="!h-[34px]"
          />
          <PlatformIcons
            platforms={platforms}
            onClickPlatform={onClickPlatform}
          />
        </div>
      </div>
      <div className="flex items-center justify-center w-px h-4 bg-dark-blue"></div>
      <div
        className={`flex items-center justify-center cursor-pointer`}
        onClick={() => setOpen(true)}
      >
        <TrashIcon className="size-[15px] text-red-status" />
      </div>
    </div>
  );
}
